<template>
  <div class="main-contain">
    <div class="module-title main-title-text ml10">系统状态示意图</div>
    <div class="echart-box">
      <tree-chart id="tree" ref="treeChartRef"></tree-chart>
      <div class="status-box">
        <el-tooltip placement="bottom-end" effect="light" :disabled="sysMsg.length < 1">
          <div slot="content">
            <div class="status-msg-red" v-for="(v, i) in sysMsg" :key="i">{{ v }}</div>
          </div>
          <div>
            <img width="13" height="13" :src="sysMsg.length < 1 ? status_normal : status_err">
            <span class="status-msg" :style="{color: sysMsg.length < 1 ? '#1fcc75' : '#f0a31e'}">{{sysMsg.length < 1 ? '正常' : '故障'}}</span>
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import TreeChart from './echartComponents/TreeChart.vue'
import { api } from '@/api/api'
export default {
  components: { TreeChart },
  data() {
    return {
      sysMsg: '',
      status_normal : require('@/assets/img/status_normal.png'),
      status_err : require('@/assets/img/status_err.png')
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$http.get({ url: api.getSystemStatus }).then(res => {
        this.sysMsg = res.data.data.msg
        let dataList = res.data.data
        this.$refs.treeChartRef.initChart(dataList)
      })
    },
  }
}
</script>

<style scoped lang="scss">
.main-contain {
  height: 100%;
  width: 100%;
  .module-title {
    height: 14%;
    width: 100%;
    display: flex;
    // justify-content: center;
    align-items: center;
  }
  .echart-box {
    height: 85%;
    width: 100%;
    position: relative;
  }
  .status-box {
    position: absolute; 
    width: 20%;
    top: -10%; 
    right: 1%;
  }
  .status-msg{
    font-size: 14px;
    margin-left: 8px;
  }
  .status-msg-green {
    color: #00c700;
    text-align: right;
    padding-right: 5%;
  }
  .status-msg-red {
    text-align: left; 
    font-size: 12px;
    margin-bottom: 3%;
    color: #F56C6C;
  }
}
</style>